import { useState } from 'react';
import { FeatureFlag } from 'src/constants/feature-flag';
import useGetFeatureFlag from 'src/helpers/hooks/useGetFeatureFlag';
import { useMount } from 'src/helpers/hooks/useMount';

type LoadingStatus = 'pending' | 'fulfilled';

export const useNewFlowFeatureFlag = () => {
  const [ren1402_newFlow, set_ren1402_newFlow] = useState<boolean>(false);
  const { getFeatureFlag } = useGetFeatureFlag();
  const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>('pending');

  useMount(() => {
    getFeatureFlag(FeatureFlag.ren1402_start_application_new_flow)
      .then((flag) => {
        set_ren1402_newFlow(flag);
        setLoadingStatus('fulfilled');
      })
      .catch(() => {
        setLoadingStatus('fulfilled');
      });
  });

  return { ren1402_newFlow, loadingStatus };
};
